import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  private readonly downloadSubject = new Subject<string>();
  download$ = this.downloadSubject.asObservable();

  triggerDownload(url: string) {
    this.downloadSubject.next(url);
  }

  downloadFile(url: string) {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.rel = "noopener";
    anchor.click();
  }
}
